import React from "react";
import PropTypes from "prop-types";
import { graphql, StaticQuery } from "gatsby";
import DisplayPrevNext from "./DisplayPrevNext";
class BlogPrevNextTemplate extends React.Component {
  render() {
    const { data } = this.props;
    const { id } = this.props;

    const { edges: posts } = data.allMarkdownRemark;

    let filteredPosts = posts.filter((posts) => posts.node.id === id.id);
    //console.log(filteredPosts);
    if (filteredPosts.length === 1) {
      let post = filteredPosts[0];
      let next = post.next;
      let previous = post.previous;

      return (
        <DisplayPrevNext
          previous={previous}
          next={next}
          beginMessage="This is our oldest blog post."
          endMessage="This is our newest blog post."
        />
      );
    } else {
      return null;
    }
  }
}

BlogPrevNext.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }),
  count: PropTypes.number,
  id: PropTypes.string,
};

export default function BlogPrevNext(pageId) {
  return (
    <StaticQuery
      query={graphql`
        query BlogPrevNextQuery {
          allMarkdownRemark(
            sort: { frontmatter: { meta: { creationDate: ASC } } }
            filter: { frontmatter: { templateKey: { eq: "blog-post" } } }
          ) {
            edges {
              node {
                id
                frontmatter {
                  title
                }
              }
              next {
                fields {
                  slug
                }
                frontmatter {
                  title
                  meta {
                    creationDate(formatString: "MMMM Do, YYYY")
                    author
                  }
                }
              }
              previous {
                fields {
                  slug
                }
                frontmatter {
                  title
                  meta {
                    creationDate(formatString: "MMMM Do, YYYY")
                    author
                  }
                }
              }
            }
          }
        }
      `}
      render={(data, count, id) => (
        <BlogPrevNextTemplate data={data} count={count} id={pageId} />
      )}
    />
  );
}
